import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../common/GridNoRow';
import axios from "axios";
import Moment from 'moment';
import Swal from "sweetalert2";
import { AppContext } from '../../../AppStore';
import WorkplaceSelectModal from "../common/WorkplaceSelectModal";
import WarehouseSelectModal from "../common/WarehouseSelectModal";
import WarehouseSectionSelectModal from "../common/WarehouseSectionSelectModal";

function WarehouseInfoModal({ title, handleView, id, onClose, workplace_id, warehouse_id, section_id, workplace_name, warehouse_name, section_name, MenuUpdateYN }) {
  const appStore = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    item_lotno: true,
    b_workplace_id: false,
    b_warehouse_id: false,
    b_section_id: false,
    a_workplace_id: false,
    a_warehouse_id: false,
    a_section_id: false,
    b_workplace_name: false,
    b_warehouse_name: false,
    b_section_name: false,
    a_workplace_name: true,
    a_warehouse_name: true,
    a_section_name: true
  });
  const columnGroupingModel = [
    {
      groupId: 'before',
      headerName: '현재',
      headerAlign: 'center',
      children: [{ field: 'b_workplace_name' }, { field: 'b_warehouse_name' }, { field: 'b_section_name' }],
    },
    {
      groupId: 'after',
      headerName: '변경',
      headerAlign: 'center',
      children: [{ field: 'a_workplace_name' }, { field: 'a_warehouse_name' }, { field: 'a_section_name' }],
    },
  ];
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [selectData, setSelectData] = useState('');
  const [upperWorkplaceId, setUpperWorkplaceId] = useState(0);
  const [upperWarehouseId, setUpperWarehouseId] = useState(0);
  const [isSelectWorkplaceModalOpen, setSelectWorkplaceModalOpen] = useState(false);
  const [isSelectWarehouseModalOpen, setSelectWarehouseModalOpen] = useState(false);
  const [isSelectWarehouseSectionModalOpen, setSelectWarehouseSectionModalOpen] = useState(false);

  useEffect(() => {
      // Mount 될때만 실행된다.
      handleSetting();
      handleInitSelect();
  }, [])

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.

  });

  const handleSetting = () => {
    setColumns([
      { field: 'id', headerName: 'id', width: 0 },
      { field: 'item_lotno', headerName: 'LotNo', width: 150, headerAlign: 'center', align:'center' },
      { field: 'item', headerName: '품목', width: 250, headerAlign: 'center', align:'left' },
      { field: 'b_workplace_id', headerName: 'b_workplace_id', width: 0 },
      { field: 'b_warehouse_id', headerName: 'b_warehouse_id', width: 0 },
      { field: 'b_section_id', headerName: 'b_section_id', width: 0 },
      { field: 'b_workplace_name', headerName: '사업장', width: 95, headerAlign: 'center', align:'left' },
      { field: 'b_warehouse_name', headerName: '창고', width: 95, headerAlign: 'center', align:'left' },
      { field: 'b_section_name', headerName: '구역', width: 95, headerAlign: 'center', align:'left' },
      { field: 'a_workplace_id', headerName: 'a_workplace_id', width: 0 },
      { field: 'a_warehouse_id', headerName: 'a_warehouse_id', width: 0 },
      { field: 'a_section_id', headerName: 'a_section_id', width: 0 },
      { field: 'a_workplace_name', headerName: '사업장', width: 160, headerAlign: 'center', align:'left' },
      { field: 'a_warehouse_name', headerName: '창고', width: 160, headerAlign: 'center', align:'left' },
      { field: 'a_section_name', headerName: '구역', width: 160, headerAlign: 'center', align:'left' }
    ]);

    setColumnVisibilityModel({
      id: false,
      item_lotno: true,
      b_workplace_id: false,
      b_warehouse_id: false,
      b_section_id: false,
      a_workplace_id: false,
      a_warehouse_id: false,
      a_section_id: false,
      b_workplace_name: false,
      b_warehouse_name: false,
      b_section_name: false,
      a_workplace_name: true,
      a_warehouse_name: true,
      a_section_name: true
    });
  }

  const handleInitSelect = () => {
    //조회
    var param_workplace_id = workplace_id;
    var param_warehouse_id = warehouse_id;
    var param_section_id = section_id;
    if(param_workplace_id === ""){
      param_workplace_id = "0";
    }
    if(param_warehouse_id === ""){
      param_warehouse_id = "0";
    }
    if(param_section_id === ""){
      param_section_id = "0";
    }
    axios.get('/api/p/WarehouseInfo/DetailList/'+(param_workplace_id+'-'+param_warehouse_id+'-'+param_section_id))
    .then((response) => {
        const array = response.data.map((item, index) => ({
          id: index,
          item: item.item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( item.item_spec, item.item_width, item.item_depth, item.item_height),
          item_lotno: item.item_lotno,
          b_workplace_id: typeof item.workplace_id === 'undefined'? null:item.workplace_id,
          b_warehouse_id: typeof item.warehouse_id === 'undefined'? null:item.warehouse_id,
          b_section_id: typeof item.section_id === 'undefined'? null:item.section_id,
          a_workplace_id: null,
          a_warehouse_id: null,
          a_section_id: null,
          b_workplace_name: item.workplace_name,
          b_warehouse_name: item.warehouse_name,
          b_section_name: item.section_name,
          a_workplace_name: '',
          a_warehouse_name: '',
          a_section_name: ''
        }));
        setRows(array);
    })
    .catch((error) => {
      appStore.capture();
    });
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'a_workplace_name' || params.field === 'lot_incoming_save_warehouse_name' || params.field === 'a_warehouse_name'){
      // 02/20 수정 // 항상 창고목록만 열음음
      setSelectModalTitle('창고 목록');
      setSelectWarehouseModalOpen(true);

      setSelectData({
        id: params.row.id,
        item: params.row.item,
        item_lotno: params.row.item_lotno,
        b_workplace_id: params.row.b_workplace_id,
        b_warehouse_id: params.row.b_warehouse_id,
        b_section_id: params.row.b_section_id,
        a_workplace_id: params.row.a_workplace_id,
        a_warehouse_id: params.row.a_warehouse_id,
        a_section_id: params.row.a_section_id,
        b_workplace_name: params.row.b_workplace_name,
        b_warehouse_name: params.row.b_warehouse_name,
        b_section_name: params.row.b_section_name,
        a_workplace_name: params.row.a_workplace_name,
        a_warehouse_name: params.row.a_warehouse_name,
        a_section_name: params.row.a_section_name
      })
    }
  };

  const handleWorkplaceClick = (object) => {
    //사업장 모달
    if(object.id !== selectData.a_workplace_id){
      setRows(rows.map((data) => data.id === selectData.id? 
        {...data, 'a_workplace_id' : object.id, 'a_workplace_name' : object.workplace_name } : data ));

    }
  };

  const handleWarehouseClick = (object) => {
    if((object.id !== selectData.a_warehouse_id) || object.section_cnt !== 0){
      if(object.section_cnt !== 0){ // 하위 section 정보가 있을 경우 section modal 켜줌
        setSelectModalTitle('구역 목록');
        setUpperWarehouseId(object.id);
        const nextSelectData = {  // 등록된 사업장/창고정보 갱신
          ...selectData,
          ['a_workplace_id'] : object.workplace_id,
          ['a_workplace_name'] : object.workplace_name,
          ['a_warehouse_id'] : object.id,
          ['a_warehouse_name'] : object.warehouse_name
        };
        
        setRows(rows.map((data) => data.id === selectData.id? 
          {...data, 'a_workplace_id' : object.workplace_id, 'a_workplace_name' : object.workplace_name, 'a_warehouse_id' : object.id, 'a_warehouse_name' : object.warehouse_name } : data ));

        setSelectData(nextSelectData);
        setSelectWarehouseSectionModalOpen(true);
      } else if (object.section_cnt === 0){
        setRows(rows.map((data) => data.id === selectData.id? 
          {...data
            , 'a_workplace_id' : object.workplace_id === ''? null:object.workplace_id
            , 'a_workplace_name' : object.workplace_name
            , 'a_warehouse_id' : object.id === ''? null:object.id
            , 'a_warehouse_name' : object.warehouse_name
            , 'a_section_id' : null
            , 'a_section_name' : '' } : data ));
      }
    }
  };

  const handleWarehouseSectionClick = (object) => {
    if(object.id !== selectData.a_section_id){
      setRows(rows.map((data) => data.id === selectData.id? 
          {...selectData
            , 'a_section_id' : object.id === ''? null:object.id
            , 'a_section_name' : object.section_name 
          } : data ));
    }
  };

  const handleSave = (event) => {
    var updateLotRows = [];
    for(var i=0; i<rows.length; i++){
      
      if(rows[i].a_workplace_id !== null || rows[i].a_warehouse_id !== null || rows[i].a_section_id !== null){
        updateLotRows.push(rows[i]);
      }
    }
    axios.post("/api/p/WarehouseInfo/Update", {updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '창고 수정 완료',
            text: '정상적으로 LotNo의 창고가 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleInitSelect();
            handleView();
          });
        }
    })
    .catch(function (error) {
      appStore.capture();
    });
  }

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto' }}>
          <div>
            <table className="ModalTABLE">
              <tbody>

                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">창고</div>
                      <div className="modal_filed_input" style={ { display:'flex', width: '769px' } }>
                       <input type="text" style={ { width: '236px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={workplace_name} name="workplace_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '236px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={warehouse_name} name="warehouse_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '236px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={section_name} name="section_name" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_grid" style={ { display:'block', height: '350px', paddingLeft: '0px', width: 'calc(100% - 50px)' } }>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        rowSpanning
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                        initialState={{ 
                            density: 'compact'
                        }}
                        onCellClick={handleOnCellClick}
                        columnGroupingModel={columnGroupingModel}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      <div className="modal_button">
                        {MenuUpdateYN === 'Y'?
                          <Button 
                            onClick={handleSave}
                            className="btn-p btn-u"
                            sx={{  
                                m: 1, 
                                fontSize: 18, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            수정
                          </Button>:<></>
                          }
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {isSelectWorkplaceModalOpen && (<WorkplaceSelectModal
          onClose={() => {
              setSelectWorkplaceModalOpen(false);
          }}
          title={selectmodalTitle}
          handleWorkplaceClick={handleWorkplaceClick}
          />)}

        {isSelectWarehouseModalOpen && (<WarehouseSelectModal
            onClose={() => {
                setSelectWarehouseModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWorkplaceId={upperWorkplaceId}
            handleWarehouseClick={handleWarehouseClick}
            />)}

        {isSelectWarehouseSectionModalOpen && (<WarehouseSectionSelectModal
            onClose={() => {
                setSelectWarehouseSectionModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWarehouseId={upperWarehouseId}
            handleWarehouseSectionClick={handleWarehouseSectionClick}
            />)}
    </PCModal>
  );
}

export default WarehouseInfoModal;